import React, { useState, useEffect } from 'react';
import { Row, Col, Image, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Landmark from '../../../assets/images/landmark-blue-icon.png'
import LandmarkSVG from '../../../assets/images/Icons/bank-white-icon.svg'
import { ArrowRight } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import PlaidData from '../../Plaid/Link';
import BankSelection from '../../Shared/BanksList/BankListSelection';
import * as actionCreator from '../../../store/Actions/Actions';
import Loader from '../../Shared/Loader/Loader';
import './FinancialDetails.css';

const FinancialDetails = (props) => {

    const [showLoader, setLoader] = useState(false);
    const [showModalLoader, setModalLoader] = useState(false);
    const dispatch = useDispatch();
    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};

    const storeData = useSelector((store) => store.bankdetailsReducer);
    const initiateLoader = () => {
        setLoader(true);
    }

    const closeLoader = () => {
        setLoader(false);
    }

    useEffect(() => {

        dispatch(actionCreator.getBankList(props.dealerId))

    }, []);

    return (<React.Fragment>
        <Loader show={showLoader} styleType='fixed' />
        <div className='onboarding-form-box-modal mb-4'>
            <h1 className="mb-4">Financial Details</h1>
            {partnerDetails && partnerDetails.enablePlaid ?
                <Row>
                    <Col>
                        <p className='secondary-text-color mb-3'>Please sign in to Plaid to connect your bank account.</p>
                        {/* <Button type="button" variant="outline-secondary" className="auto-width-btn btn-readius blue-link-text drawdown-btn float-left outline-btn blue-border-color"><Image className='mr-2' style={{ marginTop: '-5px' }} src={Landmark} fluid /> Connect Plaid</Button> */}
                        <div>
                            <PlaidData
                                buttonLabel={<span><Image className='mr-2' src={LandmarkSVG} fluid /><span className='font_weight_700 content-text-14px'>Connect Bank</span></span>}
                                disableConnect={props.disableConnect}
                                setModalLoader={(status) => setModalLoader(status)}
                                initiateLoader={initiateLoader}
                                closeLoader={closeLoader}
                                addBankAccount={() => dispatch(actionCreator.getBankList(props.dealerId))}
                                isFromOBF={true}
                                dealerId={props.dealerId}>
                                <OverlayTrigger placement="top"
                                    overlay={
                                        <Tooltip>Connect your bank account using Plaid</Tooltip>}>
                                    <h6 className="text-center mb-0">
                                        <span className="blue-link-text bold-500 letterspacing-1px text-left pl-3 d-inline-block"><Image className='mr-2' style={{ marginTop: '-5px' }} src={Landmark} fluid /> Connect Plaid</span>
                                    </h6>
                                </OverlayTrigger>
                            </PlaidData>
                        </div>
                    </Col>
                </Row> : null}
            {storeData.bankpaymentData && storeData.bankpaymentData.accounts && storeData.bankpaymentData.accounts.length > 0 ?
                <div className="p-0 onboarding-form-box-modal financial-wrapper mt-4 external-bank-acc-sec position-relative overflow-hidden">
                    <BankSelection
                        paymentDetails={storeData.bankpaymentData}
                        showAddbank={false}
                        showHeaderBank={false}
                        hideActions={true}
                        isFromOBF={true}
                        labelShow={true}
                        isDealer={true}
                        prospectDealer={true}
                        isOnboard
                        selectedDealerId={props.dealerId}

                    />
                </div>
                : ''}
            <div className='from-wrapper mt-4'>
                <Row>
                    <Col>
                        <p className='secondary-text-color mb-4'>Why do we need you to link your bank account?</p>
                        <ol className='mb-0 dealerOnboardDocs secondary-text-color'>
                            <li>This helps streamline the underwriting process.</li>
                            <li>We monitor bank account balances before collecting payoffs to prevent NSFs!</li>
                            <li>Integrations mean less manual work for you</li>
                        </ol>
                    </Col>
                </Row>

            </div>
        </div>
        <div>
            <Button type="button" onClick={(event) => props.submit(event, null, true)} variant="outline-secondary" className="default-btn">Previous</Button>
            <Button type="button" onClick={(event) => props.submit(event, null, false, true)} className="ml-3 default-btn" variant="primary">Next</Button>
        </div>
    </React.Fragment>)

}



export default FinancialDetails;